import React from "react";
import WheelComponent, { IWheelRef } from "../../components/WheelComponent";
import "./style.css"
import EventServices from "../../services/event";
import { IEventModel, IEventOrderInfoModel, IEventStoreApplyModel, ILuckyWheelSummaryModel, IPrizeModel } from "../../models/eventModel";
import Typography from "antd/lib/typography";
import { Col, Row } from "antd/lib/grid";
import Button from "antd/lib/button";
import ChooseStore from "./chooseStore";
import PopupResult, { IPopupResultRef } from "./PopupResult";
import Lottie from "lottie-react";
import animationFireworks from "../../assets/animations/fireworks.json";
import { useSelector } from "react-redux";
import { selectEventSettings } from "../../redux/reducers/slice/common";
import { selectUserInfo } from "../../redux/reducers/slice/profile";
import { useHistory } from "react-router-dom";
import { localizeRouteKey } from "../../shared/helpers";
import { isProduction } from "../../utils/helper";
const { Title } = Typography;

const LuckyWheel = () => {
  const history = useHistory();
  const userInfo = useSelector(selectUserInfo);
  const eventSettings = useSelector(selectEventSettings);

  const [event, setEvent] = React.useState<IEventModel>()
  const [store, setStore] = React.useState<IEventStoreApplyModel | null>()
  const [prizes, setPrizes] = React.useState<IPrizeModel[]>()
  const refWheelComp = React.useRef<IWheelRef>(null)
  const refPopupResult = React.useRef<IPopupResultRef>(null)
  const [order, setOrder] = React.useState<IEventOrderInfoModel | null>(null)
  const [showFireworks, setShowFireworks] = React.useState<boolean>(false)
  const [showBtnBack, setShowBtnBack] = React.useState<boolean>(true)
  const lottieRef = React.useRef<any>(null);
  const [summary, setSummary] = React.useState<ILuckyWheelSummaryModel | null>()

  React.useEffect(() => {
    checkWhitelist()
    getEventLuckyWheel()
  }, [eventSettings, userInfo])

  const checkWhitelist = () => {
    if (!eventSettings?.whitelist_phone_number || !userInfo || !isProduction()) {
      return
    }

    if (!(eventSettings.whitelist_phone_number.includes(userInfo.phone_number))) {
      history.replace(localizeRouteKey("/"))
    }
  }


  const getEventLuckyWheel = async () => {
    const rs = await EventServices.getEventLuckyWheel()
    if (!rs) {
      return
    }

    setEvent(rs)
  }

  const handleGotoBack = () => {
    setSummary(null)
    setPrizes([])
    setStore(null)
    setOrder(null)
    setShowFireworks(false)
    setShowBtnBack(true)
    refWheelComp?.current?.clearUp?.()
  }

  const handleOnError = () => {
    setShowBtnBack(true)
  }

  const segColors = [
    '#F0CF50',
    '#F9AA1F',
    '#F0CF50',
    '#F9AA1F',
    '#F0CF50',
    '#F9AA1F',
    '#F0CF50',
  ]

  const onFinished = (winner: any, _summary: ILuckyWheelSummaryModel | null) => {
    setSummary(_summary)
    setShowFireworks(true)
    lottieRef?.current?.play()
  }

  const handleAnimationCompleted = () => {
    setShowFireworks(false)
    if (refPopupResult?.current?.openPopup && order && summary?.gift_name) {
      refPopupResult.current.openPopup(order, summary?.gift_name)
      setShowBtnBack(true)
    }
  }

  const handleChangeStore = async (s: IEventStoreApplyModel | undefined, orderInfo: IEventOrderInfoModel | null) => {
    setStore(s)
    setOrder(orderInfo)
    if (!event || !s?.code) {
      return;
    }

    const response = await EventServices.getLuckyWheelPrizes(event._id, s?.code)
    if (!response) {
      return;
    }
    setPrizes(response)
  }


  const renderChooseStore = () => {
    return <ChooseStore eventId={event?._id} storeApplies={event?.store_applies} onChangeStore={handleChangeStore} />
  }


  const getSegments = () => {
    if (!prizes) {
      return []
    }
    return prizes.sort((a, b) => a.order - b.order).map(x => ({
      key: x._id,
      title: x.name,
      image_url: x.icon,
      disable: isOutOfStock(x),
      order: x.order
    }));
  }

  const render = () => {
    if (!store) {
      return renderChooseStore()
    }

    if (!prizes?.length) {
      return <div>
        prizes
      </div>
    }

    const renderPhoneNumber = () => {
      if (!order?.customerPhone?.length) {
        return ""
      }
      let phone = order.customerPhone;
      let refix = '*'.repeat(phone.length - 3)
      return refix + phone.slice(-3);
    }

    return <div>
      <Row justify={"center"} align={"middle"}>
        <Col md={12} sm={20} xs={22}>
          <Row gutter={[4, 4]} align={"middle"}>
            <Col span={12}>
              <span>Cửa hàng:</span>
            </Col>
            <Col span={12}>
              <Title level={5} >{store?.name}</Title>
            </Col>
          </Row>
          <Row gutter={[4, 4]} align={"middle"}>
            <Col span={12}>
              <span>Mã đơn hàng:</span>
            </Col>
            <Col span={12}>
              <Title level={5} >{order?.kdeOrderId}</Title>
            </Col>
          </Row>
          <Row gutter={[4, 4]} align={"middle"}>
            <Col span={12}>
              <span>Khách hàng:</span>
            </Col>
            <Col span={12}>
              <Title level={5} >{order?.customerName}</Title>
            </Col>
          </Row>
          <Row gutter={[4, 4]} align={"middle"}>
            <Col span={12}>
              <span>Số điện thoại:</span>
            </Col>
            <Col span={12}>
              <Title level={5}>{renderPhoneNumber()}</Title>
            </Col>
          </Row>
        </Col>
      </Row>
      <div>
        <WheelComponent
          segments={getSegments()}
          // winningSegment={refWinning?.current?.gift_name}
          segColors={segColors}
          onFinished={onFinished}
          primaryColor='white'
          contrastColor='white'
          buttonText='Quay'
          isOnlyOnce={true}
          upDuration={500}
          downDuration={1000}
          ref={refWheelComp}
          orderInfo={order ? {
            ...order,
            eventId: event?._id,
            storeCode: store.code
          } : null}
          onError={handleOnError}
          onSpinning={(isSpinning) => setShowBtnBack(!isSpinning)}
        // fontFamily='Arial'
        />
      </div>
      <Row justify="center">
        <Col>
          <Button disabled={!showBtnBack} onClick={handleGotoBack} type="primary">Trở về</Button>
        </Col>
      </Row>
    </div>
  }

  const renderFirework = () => {
    return showFireworks && <div className="fireworks-wrapper">
      <Lottie
        className="ctrl-lottie"
        animationData={animationFireworks}
        loop={false}
        ref={lottieRef}
        onComplete={handleAnimationCompleted} />
    </div>
  }

  return <div className="screen-lucky-wheel-master">
    {render()}
    {/* <PopupCustomer ref={refPopupCustomer} /> */}
    <PopupResult ref={refPopupResult} />
    {renderFirework()}
  </div>
}


const isOutOfStock = (prize: IPrizeModel) => {
  if (!prize) {
    return true
  }

  if (prize.out_of_stock || prize.remain_quantity == 0) {
    return true
  }

  return false
}

export default LuckyWheel;